import type { SelectOption } from "../components/Select"

/** 档位 1～6：与后端 `msg_destruct_option` 一致 */
export const MESSAGE_DESTRUCT_TIME_OPTIONS: SelectOption[] = [
  { label: "1分钟", value: "1" },
  { label: "5分钟", value: "2" },
  { label: "1小时", value: "3" },
  { label: "24小时", value: "4" },
  { label: "7天", value: "5" },
  { label: "30天", value: "6" },
]

export function getMessageDestructOptionLabel(option: number | null | undefined): string {
  const o = typeof option === "number" && option >= 1 && option <= 6 ? option : 4
  const opt = MESSAGE_DESTRUCT_TIME_OPTIONS.find((x) => Number(x.value) === o)
  return opt?.label ?? MESSAGE_DESTRUCT_TIME_OPTIONS[3].label
}
